export const AUTH_KEY = 'authKey';
export const AUTH_TOKEN = 'authToken';
export const USER_KEY = 'userName';
export const EMAIL_KEY = 'userEmail';
export const AVATAR_URL_LARGE = 'avatarUrlLarge';

// sessionStorage: set once single sign-on has been tried in this tab, to avoid reload loops
export const SSO_ATTEMPTED_KEY = 'ssoAttempted';



// WEBPACK FOOTER //
// src/helpers/storage.js